<template>
  <v-dialog v-model="dialog"
            style="z-index: 1050;"
            light
            hide-overlay
            max-width="600">
    <v-card class="offer-request-form">
      <v-form ref="offerRequestForm">
        <v-card-title>
          <h1 :style="{fontSize: $vuetify.breakpoint.xsOnly ? '18px' : ''}">Pyydä tarjousta</h1>
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text style="width: auto;">
          <div style="margin-bottom: 20px;">Täytä alla olevat tiedot niin olemme teihin yhteydessä mahdollisimman pian. Saatavuus määräytyy runkoverkon etäisyyden perusteella.</div>
            <div>
              <v-text-field background-color="white" filled label="Nimi" v-model="name"></v-text-field>
            </div>
            <div style="padding-bottom: 10px;">
              <v-text-field persistent-hint background-color="white" filled label="Puhelinnumero" v-model="phone"
                            @blur="validatePhoneNumber"
                            :error-messages="phoneNumberErrorMessages"></v-text-field>
            </div>
            <div style="padding-bottom: 10px;">
              <v-text-field persistent-hint background-color="white" filled label="Sähköposti" v-model="email"
                            @blur="validateEmail"
                            :error-messages="emailErrorMessages"
              ></v-text-field>
            </div>
            <div>
              <v-text-field background-color="white" filled label="Katuosoite" v-model="streetAddress"></v-text-field>
            </div>
            <div>
              <v-text-field background-color="white" filled label="Paikkakunta" v-model="city"></v-text-field>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn title="Peruuta" text x-large @click="dialog = false">Peruuta</v-btn>
          <v-spacer></v-spacer>
          <v-btn title="Lähetä" text x-large color="primary" :loading="loading" :disabled="!canSend" @click="send()">Lähetä</v-btn>
        </v-card-actions>
        <v-expand-transition>
          <v-card-text v-if="sendSuccess || sendFailed" class="pt-0">
            <v-alert type="success" :value="sendSuccess">Kiitos tarjouspyynnöstä! Olemme yhteydessä mahdollisimman pian.</v-alert>
            <v-alert type="error" :value="sendFailed">Jotain meni pieleen lähettäessä! Ole hyvä ja yritä uudelleen.</v-alert>
          </v-card-text>
        </v-expand-transition>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios';
  import * as math from 'mathjs';
  import params from "../params";
  import * as EmailValidator from 'email-validator';
  import libphonenumber from 'google-libphonenumber';
  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

  export default {
    name: "OfferRequestForm",
    data: () => {
      return {
        dialog: false,
        name: '',
        phone: '',
        email: '',
        streetAddress: '',
        city: '',
        loading: false,
        prices: null,
        sendSuccess: false,
        sendFailed: false,
        phoneNumberErrorMessages: ['Puhelinnumero on pakollinen tieto'],
        emailErrorMessages: ['Sähköposti on pakollinen tieto'],
      }
    },
    methods: {
      roundPrices(prices) {
        const ret = {};
        Object.keys(prices).forEach(method => {
          const p = prices[method];
          const cur = { };
          ret[method] = cur;
          Object.keys(p).forEach(paramKey => {
            const value = p[paramKey];
            if (!isNaN(value)) {
              try {
                cur[paramKey] = math.round(value, 1);
              } catch (error) {
                cur[paramKey] = value;
              }
            } else {
              cur[paramKey] = value;
            }
          });
        });
        return ret;
      },
      async send() {
        this.validatePhoneNumber();
        this.validateEmail();
        if (this.phoneNumberErrorMessages.length > 0 || this.emailErrorMessages.length > 0) {
          return;
        }
        const data = {
          contact: {
            name: this.name,
            address: this.streetAddress,
            city: this.city,
            email: this.email,
            phone: this.phone,
          },
          building: {
            type: this.buildingType.text,
            currentHeating: this.currentHeating.text,
            year: this.year.text,
            area: this.$store.state.propertySize,
            volume: this.$store.state.propertyVolume,
            distance: this.$store.state.distance,
          },
          prices: this.roundPrices(this.prices),
        };
        this.loading = true;
        this.sendSuccess = false;
        this.sendFailed = false;

        try {

          if (process.env.NODE_ENV === 'development') {
            console.log('send_offer_request_data', data);
          } else {
            await axios.post('https://dheat-sales-2025.azurewebsites.net/api/offerRequest?code=llDxobsmZatMMP9c-cea73HF5f_jyslbj-gDlG6AGu-MAzFukjNdhA==', data);
          }

          this.$sendAnalyticsEvent('offer-requested');
          this.$offerRequestSent();
          this.sendSuccess = true;
        } catch (error) {
          console.log(error);
          this.sendFailed = true;
        }
        this.loading = false;
      },
      open(prices) {
        this.prices = prices;
        this.dialog = true;
      },
      validatePhoneNumber() {
        const ret = [];
        if (this.phone.length === 0) {
          ret.push('Puhelinnumero on pakollinen tieto')
        } else if (!this.isValidPhoneNumber) {
          ret.push('Tarkista että puhelinnumero on oikein')
        }
        this.phoneNumberErrorMessages = ret;
      },
      validateEmail() {
        const ret = [];
        if (this.email.length === 0) {
          ret.push('Sähköposti on pakollinen tieto')
        } else if (!this.isValidEmail) {
          ret.push('Tarkista että sähköposti on oikein')
        }
        this.emailErrorMessages = ret;
      }
    },
    computed: {
      isValidPhoneNumber() {
        try {
          const number = phoneUtil.parse(this.phone, 'fi')
          return phoneUtil.isValidNumber(number, 'fi');
        } catch (error) {
          return false;
        }
      },
      isValidEmail() {
        return EmailValidator.validate(this.email);
      },
      canSend() {
        return this.phone.length > 0 && this.isValidPhoneNumber && this.email.length > 0 && this.isValidEmail;
      },
      year() {
        return params.years.find(t => t.value === this.$store.state.buildingYear);
      },
      currentHeating() {
        return params.heatingMethods.find(t => t.value === this.$store.state.currentHeating);
      },
      buildingType() {
        return params.buildingTypes.find(t => t.value === this.$store.state.buildingType);
      },
    },
    watch: {
      dialog(val) {
        if (!val) {
          this.sendSuccess = false;
          this.sendFailed = false;
        }
      }
    }
  }
</script>

<style lang="scss">
  .offer-request-form {
    .v-input {
      border-radius: 3px;
    }

    .v-input__slot {
      box-shadow: none !important;

      &.white {
        border: 1px solid rgba(0,0,0,0.35) !important;
      }

      &::before {
        display: none;
      }
    }
  }
</style>
